import {Component, forwardRef, Injector, OnChanges, SimpleChanges} from "@angular/core";
import {ColumnComponent} from "../../../framework/entity/grid/column.component";
import {
    AbstractSingleSelectColumnComponent
} from "../../../framework/entity/edit/edit-grid/columns/abstract-single-select-column.component";

@Component({
    selector: "wbo-category-single-select-column",
    templateUrl: "./category-single-select-column.component.html",
    providers: [
        {provide: ColumnComponent, useExisting: forwardRef(() => CategorySingleSelectColumnComponent), multi: true}
    ]
})
export class CategorySingleSelectColumnComponent extends AbstractSingleSelectColumnComponent implements OnChanges {
    constructor(injector: Injector) {
        super(injector);
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.valueField = this.field + ".categoryId";
        this.labelField = this.field + ".name";
    }
}
